import Dexie, { Table } from 'dexie';
import { IWorkflow, IWorkflowState } from '../interfaces/configuration/IConfiguration';
import { ICacheAlias, ICacheItem } from '../interfaces/IItem';
import { IMfilesObjectClass } from '../interfaces/mfiles/IMfilesObjectClass';
import { IMFilesObjectType } from '../interfaces/mfiles/IMFilesObjectType';
import IMFilesPropertyDefinition from '../interfaces/mfiles/IMFilesPropertyDefinition';
import IMfilesValueListDefinition from '../interfaces/mfiles/IMFilesValueListDefinition';

class GanttDB extends Dexie {

  aliases: Table<ICacheAlias, string>;
  items: Table<ICacheItem, [number, number]>;
  objectTypeClasses: Table<IMfilesObjectClass[], number>;
  objectTypes: Table<IMFilesObjectType, number>;
  propertyDefinitions: Table<IMFilesPropertyDefinition, number>;
  valueLists: Table<IMfilesValueListDefinition, number>;
  workflows: Table<IWorkflow, number>;
  workflowStates: Table<IWorkflowState[], number>;
  

  constructor () {
    super("GanttDB");
    this.version(1).stores({
      aliases: "",
      items: "[objectType+objectId]",
      objectTypes: "ID",
      objectTypeClasses: "",
      propertyDefinitions: "ID",
      valueLists: "ID",
      workflows: "ID",
      workflowStates: "",
    });
  }

  clearMetadata = () => {
    this.aliases.clear();
    this.objectTypes.clear();
    this.objectTypeClasses.clear();
    this.propertyDefinitions.clear();
    this.valueLists.clear();
    this.workflows.clear();
    this.workflowStates.clear();
  };

}

const ganttDB = new GanttDB();

export default ganttDB;